import { useId } from 'react';

/** Payroll mark — orange and navy coin with verify check and ADP badge. */
export default function AppLogo({ size = 40, className = '' }) {
  const id = useId().replace(/:/g, '');

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id={`${id}-bg`} x1="4" y1="4" x2="44" y2="44" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1e3a5f" />
          <stop offset="1" stopColor="#0c1e35" />
        </linearGradient>
        <linearGradient id={`${id}-coin`} x1="12" y1="10" x2="36" y2="38" gradientUnits="userSpaceOnUse">
          <stop stopColor="#234876" />
          <stop offset="1" stopColor="#132743" />
        </linearGradient>
        <linearGradient id={`${id}-orange`} x1="28" y1="28" x2="40" y2="42" gradientUnits="userSpaceOnUse">
          <stop stopColor="#fb923c" />
          <stop offset="1" stopColor="#ea580c" />
        </linearGradient>
      </defs>

      <rect width="48" height="48" rx="12" fill={`url(#${id}-bg)`} />
      <rect width="48" height="48" rx="12" fill="none" stroke="#234876" strokeWidth="1" />

      {/* Pay coin */}
      <circle cx="24" cy="22" r="15" fill={`url(#${id}-coin)`} stroke="#f97316" strokeWidth="2.5" />

      {/* Verified check */}
      <path
        d="M15 22L20.5 27.5L33 16"
        stroke="#fdba74"
        strokeWidth="3.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Pay lines */}
      <rect x="16" y="30.5" width="16" height="1.75" rx="0.875" fill="#3b5f8c" />
      <rect x="18" y="33.5" width="12" height="1.75" rx="0.875" fill="#f97316" opacity="0.85" />

      {/* ADP badge */}
      <circle cx="35.5" cy="35.5" r="7.25" fill={`url(#${id}-orange)`} stroke="#0c1e35" strokeWidth="1.5" />
      <text
        x="35.5"
        y="38.75"
        textAnchor="middle"
        fill="#fff7ed"
        fontSize="10"
        fontWeight="800"
        fontFamily="ui-sans-serif, system-ui, sans-serif"
      >
        A
      </text>
    </svg>
  );
}
